import { Card, CardContent, CardHeader, CardTitle } from '@klear/ui/components/card'
import { useDocumentTitle } from '@klear/ui/hooks/use-document-title'

export default function KlearFX() {
  useDocumentTitle('KlearFX')
  return (
    <div className="container mx-auto px-2 py-6 space-y-6">
      <h1 className="text-2xl font-bold">KlearFX</h1>

      <Card>
        <CardHeader>
          <CardTitle>Access KlearFX</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">
            Currently invite only. Contact your account manager if you have not already received an invite.
          </p>
        </CardContent>
      </Card>
    </div>
  )
}
